// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"709":"522407a8","882":"75aaa906"}[chunkId] + ".chunk.js";
};